import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {EmpresaDetalhes} from "../models/empresa-detalhes";
import {NovaEmpresa} from "../models/nova-empresa";
import {NovoClienteResponse} from "../models/novo-cliente-response";
import {AssinarRequest} from "../../../core/models/assinar-request";

@Injectable({
  providedIn: 'root'
})
export class EmpresaService{
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`EmpresaService`);
  }

  baseUrl = environment.apiUrl;

  buscarDetalhes(): Observable<BaseResponse<EmpresaDetalhes> | BaseResponse<any>>{
    return this.http
      .get<BaseResponse<EmpresaDetalhes>>(`${this.baseUrl}/Empresa/Detalhes`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarDetalhes')));
  }

  adicionar(novaEmpresa: NovaEmpresa): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Empresa`, novaEmpresa)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  novoCliente(novaEmpresa: NovaEmpresa): Observable<BaseResponse<NovoClienteResponse> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<NovoClienteResponse>>(`${this.baseUrl}/Empresa/NovoCliente`, novaEmpresa)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('novoCliente')));
  }

  assinarPlano(request: AssinarRequest): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .post<BaseResponse<boolean>>(`${this.baseUrl}/Empresa/AssinarPlano`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('assinarPlano')));
  }

  checarPagamento(empresaId: number): Observable<BaseResponse<boolean> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<boolean>>(`${this.baseUrl}/Empresa/ChecarPagamento/${empresaId}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('checarPagamento')));
  }
}
